import License from './License';

export default License
export { License as Base }